<template>
  <el-dialog
    :title="setId ? '编辑角色' : '新增角色'"
    :visible.sync="roleDialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    width="600px"
    center
  >
    <el-form
      :model="roleForm"
      :rules="rules"
      ref="roleForm"
      label-width="100px"
    >
      <el-form-item label="角色名称" prop="name">
        <el-input
          v-model="roleForm.name"
          placeholder="请输入角色名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="所属项目" prop="project">
        <el-select
          v-model="roleForm.project"
          placeholder="请选择所属项目"
          style="width: 100%;"
        >
          <el-option
            v-for="item in projectList"
            :key="item.item_id"
            :label="item.item_name"
            :value="item.item_id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属模块" prop="region">
        <el-select
          v-model="roleForm.region"
          placeholder="请选择所属模块"
          style="width: 100%;"
          @change="chiosemenus"
        >
          <el-option
            v-for="item in regionList"
            :key="item.type"
            :label="item.name"
            :value="item.type"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="协调中心"
        prop="xietiao"
        v-if="Number(roleForm.region) === 6"
      >
        <el-select
          v-model="roleForm.xietiao"
          placeholder="请选择所属协调中心"
          style="width: 100%;"
          @change="chiosemenus2"
        >
          <el-option label="培训协调中心" value="2"></el-option>
          <el-option label="实习协调中心" value="3"></el-option>
          <el-option label="考场协调中心" value="4"></el-option>
          <el-option label="教学协调中心" value="5"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注" prop="desc">
        <el-input
          type="textarea"
          v-model="roleForm.desc"
          placeholder="请输入备注"
        ></el-input>
      </el-form-item>
      <el-form-item label="权限设置" prop="menu" v-if="roleForm.region">
        <el-tree
          :data="menus"
          show-checkbox
          node-key="menu_id"
          ref="tree"
          default-expand-all
          :default-checked-keys="roleForm.menu"
          @check-change="handleCheckChange"
          :props="defaultProps"
        >
        </el-tree>
      </el-form-item>
      <el-form-item class="flex align-center justify-around" label-width="0">
        <el-button class="padding-lr-xl" @click="resetForm('roleForm')"
          >取消
        </el-button>
        <el-button
          class="padding-lr-xl"
          type="primary"
          @click="submitForm('roleForm')"
          >提交
        </el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { roleAdd, itemlist, menusList } from "@/api/admin";

export default {
  name: "roleDialog",
  props: {
    roleDialog: {
      type: Boolean,
      default: false
    },
    setId: {
      type: Number,
      default() {
        return 0;
      }
    },
    setItem: {
      type: Object
    }
  },
  data() {
    return {
      projectList: [],
      menus: [],
      defaultProps: {
        children: "children",
        label: "name"
      },
      roleForm: {
        name: "",
        project: "",
        region: "",
        xietiao: "",
        desc: "",
        menu: [],
        menuOther: []
      },
      rules: {
        name: [{ required: true, message: "请输入角色名称", trigger: "blur" }],
        project: [
          { required: true, message: "请选择所属项目", trigger: "change" }
        ],
        region: [
          { required: true, message: "请选择所属模块", trigger: "change" }
        ],
        xietiao: [
          { required: true, message: "请选择所属协调中心", trigger: "change" }
        ],
        menu: [{ required: true, message: "请设置权限", trigger: "change" }]
      }
    };
  },
  computed: {
    regionList() {
      return [
        { type: 1, name: "项目办" },
        { type: 2, name: "认证培训机构" },
        { type: 3, name: "实习基地" },
        { type: 4, name: "考场" },
        { type: 5, name: "产教融合基地" },
        { type: 6, name: "协调中心" }
      ];
    }
  },
  created() {
    this.getProject();
  },
  methods: {
    async getProject() {
      let _list = await itemlist("", "", 1, 10000);
      this.projectList = _list.data.list;
    },
    chiosemenus(val) {
      this.roleForm.menu = [];
      this.getmenus(val);
    },
    async getmenus(val) {
      if (val !== 6) {
        let _list = await menusList(val, 0);
        this.menus = _list.data;
      } else {
        this.menus = [];
      }
    },

    chiosemenus2(val) {
      this.roleForm.menu = [];
      this.getmenus2(val);
    },

    async getmenus2(val) {
      let _list = await menusList(this.roleForm.region, val);
      this.menus = _list.data;
    },
    handleCheckChange() {
      this.roleForm.menu = this.$refs.tree.getCheckedKeys();
      this.roleForm.menuOther = this.$refs.tree.getHalfCheckedKeys();
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$emit("cancelDialog", false);
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.submitData(formName);
        }
      });
    },
    async submitData(formName) {
      let _state = await roleAdd(
        this.roleForm.name,
        this.roleForm.project,
        this.roleForm.region,
        this.roleForm.xietiao,
        this.roleForm.desc,
        JSON.stringify({
          menus1: this.roleForm.menu,
          menus2: this.roleForm.menuOther
        }),
        this.setId,
        1
      );
      this.$message.success(_state.msg);
      this.$refs[formName].resetFields();
      this.$emit("cancelDialog", true);
    }
  },
  watch: {
    setItem() {
      if (this.setItem.role_name) {
        this.roleForm = {
          name: this.setItem.role_name,
          project: this.setItem.item_id,
          region: this.setItem.region_id,
          xietiao: this.setItem.xietiao ? this.setItem.xietiao.toString() : "",
          desc: this.setItem.remark,
          menu: JSON.parse(this.setItem.menu_ids).menus1,
          menuOther: JSON.parse(this.setItem.menu_ids).menus2
        };
        if (Number(this.setItem.region_id) !== 6) {
          this.getmenus(this.roleForm.region);
        } else {
          this.getmenus2(this.setItem.xietiao);
        }
      }else{
        this.$nextTick(()=>{
          this.$refs['roleForm'].resetFields();
        })
      }
    }
  }
};
</script>

<style scoped lang="scss"></style>
